import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IPermissionState {
  contactGroup?: string | null;
}

const loadState = () => {
  const data = localStorage.getItem("permission");
  if (!data)
    return {
      contactGroup: null,
    };
  return JSON.parse(data);
};

const initialState: IPermissionState = loadState();

const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    setPermission: (state, action: PayloadAction<IPermissionState>) => {
      return { ...action.payload };
    },
    updatePermission: (
      state,
      action: PayloadAction<Partial<IPermissionState>>
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetPermission: () => initialState,
  },
});

export const { setPermission, updatePermission, resetPermission } =
  permissionSlice.actions;
export default permissionSlice.reducer;
